import "./Giraffe.css";
import "./Gallery.css";
import GalleryItem from "./Gallery";

const GCS_BASE_URL = "https://storage.googleapis.com/portfolio-media-circus";

const title = "El corazón del jirafa (The Giraffe's Heart)";
const text = `In this 20-minute show, Colombian juggler Carlos invites you into a
world of balance and
          invisible forces. With every throw, every spin, and every catch,
          gravity is challenged. Hats, clubs, and a two-meter unicycle meet in a
          dance between the possible and the impossible. 
          
          The show moves between
          intense movement, moments of stillness, and humor, pulling the
          audience into the action and keeping them in constant anticipation —
          all to the rhythm of salsa music. An experience for all ages that
          awakens both body and mind — a celebration of the human capacity to
          push the boundaries of reality, and the free, intimate connection that
          street circus creates with its audience.
          
          Performer: Carlos Lopez`;
function Giraffe() {
  return (
    <>
      <section className="giraffe">
        <div>
          <h1>{title}</h1>
          <div className="projects-grid">
            <div className="flexbox-item">
              <GalleryItem
                fileName={"corazon-de-jirafa-monociclo-cropped.png"}
                alt="Carlos Mario Lopez performing giraffe unicycle in Giraffens Hjärta"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
            </div>
            <div className="flexbox-item">
              <GalleryItem
                fileName={"corazon-de-jirafa-entrada.png"}
                alt="Carlos Mario Lopez performing giraffe unicycle in Giraffens Hjärta"
                style={{ width: "100%", height: "80%", zoom: "200%" }}
              ></GalleryItem>
            </div>
          </div>
          <p>
            In this 20-minute show, Colombian juggler Carlos invites you into a
            world of balance and invisible forces. With every throw, every spin,
            and every catch, gravity is challenged. Hats, clubs, and a two-meter
            unicycle meet in a dance between the possible and the impossible.
            <br></br>
            <br></br>
            The show moves between intense movement, moments of stillness, and
            humor, pulling the audience into the action and keeping them in
            constant anticipation, all to the rhythm of salsa music.
            <br></br>
            <br></br>
            An experience for all ages that awakens both body and mind: a
            celebration of the human capacity to push the boundaries of reality,
            and the free, intimate connection that street circus creates with
            its audience.
            <br></br>
            <br></br>
            Performer: Carlos Lopez
          </p>
        </div>
      </section>
    </>
  );
}

export default Giraffe;
